import './Toast.scss'
import { Toast as BootstrapToast } from 'react-bootstrap'
import React from 'react'
import { ToastProps as BootstrapToastProps } from 'react-bootstrap/Toast'
import { Divider } from '../Divider/Divider'

export type ToastVariant = 'error' | 'warning' | 'info' | 'success'

export interface ToastProps extends BootstrapToastProps {
  variant?: ToastVariant
  delay?: number
}

export const Toast: React.FC<ToastProps> = ({ variant, delay = 3000, children, onClose, ...rest }) => {
  const variantClassMap: { [key: string]: string } = {
    error: 'toast toast-error',
    warning: 'toast toast-warning',
    info: 'toast toast-info',
    success: 'toast toast-success',
  }

  const variantIconMap = {
    error: 'bi-x-circle-fill',
    warning: 'bi-exclamation-triangle-fill',
    info: 'bi-info-circle-fill',
    success: 'bi-check-circle-fill',
  }

  return (
    <BootstrapToast show={true} className={variantClassMap[variant || 'info']} onClose={onClose} delay={delay} autohide={true} {...rest}>
      <div className='d-flex justify-content-between pb-2'>
        <div>
          <div className='d-flex gap-2'>
            <i className={`bi ${variantIconMap[variant || 'info']}`} />
            <div className='lead-medium'>{rest.title ? rest.title : 'Something went wrong!'}</div>
          </div>
        </div>
        <div role='button' onClick={() => onClose && onClose()}>
          <i className='bi bi-x' />
        </div>
      </div>
      <Divider />
      <div className='pt-2'>
        <div>{children}</div>
      </div>
    </BootstrapToast>
  )
}
